import { make, getStaticProps as getStaticProps_ } from "../src/common/PagePlans.bs.js";
import { withApollo } from "../utils/withApollo.js";

export default withApollo(make);

export const getStaticProps = getStaticProps_;
